import { useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { ComponentSize } from "../types";
import { Button } from "../Button";
import { MenuItem } from "./MenuItem";
import type { MenuItemType } from "./MenuItem";

export const Menu = ({
    items,
    size = ComponentSize.MD,
    defaultExpanded = false,
    className = "",
    showExpandToggle = false,
}: MenuProps) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const menuClasses = classNames(
        "menu",
        "bg-base-200 rounded-box",
        size === ComponentSize.XL ? "menu-xl" : "",
        size === ComponentSize.LG ? "menu-lg" : "",
        size === ComponentSize.MD ? "menu-md" : "",
        size === ComponentSize.SM ? "menu-sm" : "",
        size === ComponentSize.XS ? "menu-xs" : "",
        className,
    );

    return (
        <>
            {showExpandToggle && (
                <div className="flex justify-end mb-4">
                    <Button
                        color="link"
                        size={ComponentSize.SM}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        <FontAwesomeIcon
                            icon={isExpanded ? faChevronUp : faChevronDown}
                        />
                        {isExpanded ? "Collapse all" : "Expand all"}
                    </Button>
                </div>
            )}
            <ul className={menuClasses}>
                {items.map((item) => (
                    <MenuItem
                        key={item.id}
                        item={item}
                        defaultExpanded={isExpanded}
                    />
                ))}
            </ul>
        </>
    );
};

export interface MenuProps {
    items: MenuItemType[];
    size?: ComponentSize;
    defaultExpanded?: boolean;
    className?: string;
    showExpandToggle?: boolean;
}

export type { MenuItemType as MenuItem };
export default Menu;